<mat-toolbar class="grid-container" color="primary">
	<div class="item item1">
		@if ((this.cliente.getClienteFilial !== undefined)) {
		<img class="borda-logo"
			src="{{logoEmpresa}}" (click)="getRouterLink()" >
		}
	</div>
	@if (logoMini) {
	<div>
		<img class="borda-logo logo-imagem-mini" src="assets/images/logo_mini.png"(click)="getRouterLink()">
	</div>
	}
	@if (isCliente && pesquisaVisivel && temAcesso) {
	<div class="item item3">
		<app-search-bar #searchbar (idsPesquisaEmitter)="emitIdsPesquisa($event)"
			(isLoadingEmitter)="emitIsLoading($event)" (ocultaAbasEmitter)="emitOcultarAbas($event)" [consultaDetalhada]="consultaDetalhada"
			[qtdFiltros]="qtdFiltros" (openDialog)="openDialogPesquisaDetalhada()" [aplicarFiltros]="aplicarFiltros">
		</app-search-bar>
	</div>
	}
	<div [ngClass]="(temAcesso) ? 'item4':'item5'" class="item">
		<app-menu [nomeUsuario]="nomeUsuario" [isCliente]="isCliente"></app-menu>
	</div>
	@if (utilizaMural) {
	<div class="item item5 notification-container">
		<mat-icon [matBadge]="mensagensNaoLidas"
				[matBadgeHidden]="mensagensNaoLidas === 0"
				matBadgeColor="warn"
				matBadgePosition="above after"
				matBadgeSize="medium"
				(click)="abrirNotificacoes()">notifications</mat-icon>
	</div>
	}
	@if (isCliente && temAcesso) {
	<div class="item item6">
		<app-carrinho-menu #cartmenu></app-carrinho-menu>
	</div>
	}
</mat-toolbar>
@if (temWhatsapp) {
<a [href]="'https://wa.me/'+whatsapp" target="_blank">
	<img src="assets/images/whatsapp.png" class="icone-whatsapp">
</a>
}
